import { AbstractCommand } from 'src/models/command';

class SaveTheIdoContactPersonCommand extends AbstractCommand {
	public apiVersion = 2;
	readonly name = 'IFS_IDO_Command_Command_SaveTheIdoContactPersonCommand';

	public constructor(idoId: string, idoInstanceId: string, jsonPayload: string) {
		super();
		this.parameters = {
			idoId: idoId,
			idoInstanceId: idoInstanceId,
			jsonPayload: jsonPayload,
		};
	}
}

export { SaveTheIdoContactPersonCommand };
